import * as React from "preact";
// React core
import { FunctionComponent } from "preact";

// Vendor
import cx from "classnames";

export interface ISVGIconProps {
  spriteUrl?: string;
  name: string;
  className?: string;
  loading?: boolean;
}

const SVGIcon: FunctionComponent<ISVGIconProps> = ({
  name,
  className = "",
  spriteUrl = "/Content/images/v3/svg-sprite.svg",
}) => {
  return (
    <svg
      className={cx("icon", className)}
      focusable="false"
    >
      <use xlinkHref={`${spriteUrl}#${name}`} />
    </svg>
  );
};
export default SVGIcon;
